import { makeOptionsWithNull } from 'Common/FormHelper';

export const FractionalEnum = {
  '1/8': 0.125,
  '1/4': 0.25,
  '1/3': 0.3333,
  '3/8': 0.375,
  '1/2': 0.5,
  '5/8': 0.625,
  '2/3': 0.6667,
  '3/4': 0.75,
  '7/8': 0.875,
};

export const FractionalDropdownOptions = makeOptionsWithNull(
  Object.keys(FractionalEnum).map(key => ({
    Id: key,
    Description: key,
  })),
  undefined,
  data => data
);



// WEBPACK FOOTER //
// ./src/common/Constants/Enumeration/FractionalEnum.js